import * as React from "react";
import "./footer.scss";
import {cs} from "../../../../../../../../../../../react/chain-services";

export const Footer = ({onAddBuilding, onViewAll, summary}) => cs(
    ({}) => (
        <div className="footer-3dm">
            <div className="left">
                <table className="summary-table">
                    <tbody>
                    <tr>
                        <td className="label" xd-qa-type="label" xd-qa-name="Coop Condo List Total Addresses">Total Addresses</td>
                        <td className="value" xd-qa-type="text" xd-qa-name="Coop Condo List Total Addresses">
                            {summary.addressesCount}
                        </td>
                        <td className="actions">
                            <a
                                onClick={onViewAll}
                                xd-qa-type="link"
                                xd-qa-name="Coop Condo List View All"
                            >View All</a>
                        </td>
                    </tr>
                    <tr className="bold">
                        <td className="label" xd-qa-type="label" xd-qa-name="Coop Condo List Total Buildings">Total Buildings</td>
                        <td className="value" xd-qa-type="text" xd-qa-name="Coop Condo List Total Buildings">
                            {summary.buildingsCount}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div className="right">
                <button
                    onClick={onAddBuilding}
                    xd-qa-type="button"
                    xd-qa-name="Coop Condo List Add New Address"
                >ADD NEW ADDRESS</button>
            </div>
        </div>
    ),
);